import React, { memo, useState, useRef } from 'react';
import Select from 'react-select';
import { findIndex } from 'lodash';
import styles from './sort.module.scss';
import { useGlobalDataContext } from '@context/GlobalData/GlobalDataContext';
import { useLoading } from '@context/Loading/LoadingContext';
import { defaultConfig, sortConfig, searchStates } from '@config';

const Sort = memo(({ inputRef }) => {
    const sortSelect = useRef(null);
    const { globalContext, setGlobalContext } = useGlobalDataContext();
    const { setLoading } = useLoading();
    const [sortOptions] = useState(sortConfig);
    const sortCurrent = findIndex(sortOptions, { value: globalContext.sort });
    const defaultSort = findIndex(sortOptions, { value: defaultConfig.sort });

    // selectorStyles object
    const customStyles = {
        option: (styles, state) => ({
            ...styles,
            cursor: 'pointer'
        }),
        control: styles => ({
            ...styles,
            cursor: 'pointer'
        })
    };

    // Invoke when user clicks to sort.
    const handleSortChange = event => {
        setLoading(true);
        // Let's get the default value if the react-select input is cleared
        if (!event) {
            event = {
                value: sortOptions[defaultSort]?.value
            };
        }

        setGlobalContext(prevContext => ({
            ...prevContext,
            start: 1,
            sort: event.value,
            searchState: searchStates.UPDATING,
            prevSearchState: prevContext.searchState
        }));
    };

    return (
        <div className={`op-sort ${styles.container}`}>
            <Select
                className={`op-sort`}
                classNamePrefix="react-select"
                styles={`${customStyles}`}
                options={sortOptions
                    .sort((a, b) => +b.isDefault - +a.isDefault)
                    .map(({ value, label }, index) => ({
                        value,
                        label,
                        sortIndex: index
                    }))}
                // placeholder={"orderBy"}
                isClearable
                ref={sortSelect}
                isSearchable={false}
                value={{
                    value: sortOptions[sortCurrent]?.value,
                    label: sortOptions[sortCurrent]?.label
                }}
                onChange={event => {
                    handleSortChange(event);
                }}
            />
        </div>
    );
});

export default Sort;
